import React from 'react'
import {IconButton, Tooltip} from "@material-ui/core";

export default ({disabled, onClick, title, children}) => (
  <Tooltip title={title}>
    <IconButton disabled={disabled} onClick={onClick}>
      {children}
    </IconButton>
  </Tooltip>
)


// WEBPACK FOOTER //
// ./src/components/counseling-session/enter-factors/Factor/FactorButton.js